import React from 'react';

interface SwabIconProps {
  color?: string;
  className?: string;
}

const SwabIcon: React.FC<SwabIconProps> = ({ color, className }) => {
  const tubeColor = color || "#FFFFFF"; // Default color if none provided

  return (
    <svg viewBox="0 0 24 27" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M12.75 26.3572C11.5073 26.3572 10.5 25.3499 10.5 24.1072V5.5H15V24.1072C15 25.3499 13.9927 26.3572 12.75 26.3572Z" fill={tubeColor} stroke="#0C3058" strokeWidth="0.8"/>
      <path d="M10.5 5.5L9.75 3.75H15.75L15 5.5H10.5Z" fill="#none" stroke="#0C3058" strokeWidth="0.8"/>
      <path d="M9.75 3.75L9 2H16.5L15.75 3.75H9.75Z" fill="none" stroke="#0C3058" strokeWidth="0.8"/>
      <ellipse cx="12.75" cy="1.25" rx="4" ry="0.75" fill="#FFFFFF" stroke="#0C3058" strokeWidth="0.8"/>
      <path d="M10.25 1.25C10.25 1.25 10.5 0.5 11 0.75" stroke="#0C3058" strokeWidth="0.3"/>
      <path d="M11.5 1C11.5 1 11.75 0.25 12.25 0.5" stroke="#0C3058" strokeWidth="0.3"/>
      <path d="M12.75 0.75C12.75 0.75 13 0 13.5 0.25" stroke="#0C3058" strokeWidth="0.3"/>
      <path d="M14 1C14 1 14.25 0.25 14.75 0.5" stroke="#0C3058" strokeWidth="0.3"/>
      <path d="M15.25 1.25C15.25 1.25 15.5 0.5 16 0.75" stroke="#0C3058" strokeWidth="0.3"/>
    </svg>
  );
};

export default SwabIcon;
